// extracted by mini-css-extract-plugin
export var codeoverflow = "style-module--codeoverflow--RCRBn";
export var panel = "style-module--panel--04Id5";